module.exports = __webpack_public_path__ + "media/components/web/layout/footer_background-3941c3c200ea0f239961f72f67907ab9.svg";